// extracted by mini-css-extract-plugin
module.exports = {"progressWrapper":"Progress_progressWrapper__3-HcS"};